import { UniversalCompareHelper } from '@biteinc/helpers-universal';
export const asc = UniversalCompareHelper.asc;
export const desc = UniversalCompareHelper.desc;
export const ascBool = UniversalCompareHelper.ascBool;
export const descBool = UniversalCompareHelper.descBool;
export const ascStr = UniversalCompareHelper.ascStr;
//# sourceMappingURL=compare_helper.js.map